import Vue from 'vue';
import { Resolve } from 'vue-di';
import styles from '~/assets/style/variables.scss';
import SessionModule from '~/store/session';

export default class BaseView extends Vue {
    constructor() {
        super();
    }

    @Resolve
    session!: SessionModule;

    styles = styles;
    isLoading = false;

    protected get componentName(): string {
        return this.constructor.name;
    }

    get isDisableButton() {
        return this.$v.$invalid;
    }
}
